import index from "./offline.vue";
export default index;
